import { connect } from 'react-redux'

import { setWaiverForms } from 'actions/account/forms/waiverForms'

const mapStateToProps = ({ forms: { waiverForms } }) => ({
  waiverForms
})

const actions = {
  setWaiverForms
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
